/*
///////////////////
  DOM ELEMENTS
//////////////////
*/
const quantityInput = document.getElementById("quantity")
const minusButton = document.querySelector(".minus")
const plusButton = document.querySelector(".plus")
const productForm = document.getElementById("product-form")
let variantIdInput = document.querySelector('input[name="id"]:checked')
const radioInputs = document.querySelectorAll('input[name="id"]')
const drawerCartTarget = document.getElementById("drawer-cart-target")
const confirmationModal = document.getElementById(
  "custom-fields-confirmation-modal"
)

/*
///////////////////
  API Request Functions
//////////////////
*/
const axiosPost = (url, data) => axios.post(url, data)
const axiosGet = (url) => axios.get(url)
const axiosChange = async (endpoint, data) => {
  await axiosPost(endpoint, data)
  return axiosGet("/cart.js")
}

/*
///////////////////
  Event listener abstraction for custom HTML elements
//////////////////
*/
const addEventListenerToClass = (className, eventType, callback) => {
  const elements = document.getElementsByClassName(className)
  Array.from(elements).forEach((element) =>
    element.addEventListener(eventType, callback)
  )
}
// Custom HTML elements
class CustomHTMLElement extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.onClick)
  }
}
class RemoveItemButton extends CustomHTMLElement {
  onClick(event) {
    const variantKey = this.closest("[data-key]").getAttribute("data-key")
    const item = this.closest(".drawer-line-item")
    handleRemoveItem(item, variantKey)
  }
}
class AdjustQuantityButton extends CustomHTMLElement {
  onClick(event) {
    const operation = this.classList.contains("minus") ? "minus" : "plus"
    adjustDrawerItemQuantity(operation, this)
  }
}
class ConfirmFieldsButton extends CustomHTMLElement {
  onClick(event) {
    confirmationModal.classList.add("hidden")
    const properties = Array.from(
      document.querySelectorAll(".custom-line-item-field")
    ).reduce((acc, field) => ({ ...acc, [field.name]: field.value }), {})
    submitForm(properties)
  }
}
class CancelFieldsButton extends CustomHTMLElement {
  onClick(event) {
    confirmationModal.classList.add("hidden")
  }
}
class DrawerAddToCartButton extends CustomHTMLElement {
  async onClick(event) {
    const variantId = this.closest("li").getAttribute("data-id")
    try {
      await axiosPost("/cart/add.js", {
        id: variantId,
        quantity: 1,
      })
      const response = await axiosGet("/cart.js")

      const drawerResponse = await axiosGet("?section_id=drawer-cart")
      const data = drawerResponse.data
      drawerCartTarget.innerHTML = data
    } catch (error) {
      console.error("Could not add item to cart", error)
    }
  }
}

customElements.define("remove-item-button", RemoveItemButton)
customElements.define("adjust-quantity-button", AdjustQuantityButton)
customElements.define("confirm-fields-button", ConfirmFieldsButton)
customElements.define("cancel-fields-button", CancelFieldsButton)
customElements.define("drawer-add-to-cart-button", DrawerAddToCartButton)

/*
///////////////////
  Helper Functions
//////////////////
*/
const getQuantity = () => parseInt(quantityInput.value)
const setQuantity = (value) => {
  quantityInput.value = value
}

const toggleSpinner = (item, isVisible) => {
  item.style.display = isVisible ? "block" : "none"
}

const adjustQuantity = (operation) => {
  const quantity = getQuantity()
  if (
    (operation === "minus" && quantity > 0) ||
    (operation === "plus" && quantity < 24)
  ) {
    setQuantity(operation === "minus" ? quantity - 1 : quantity + 1)
  }
}
const waitForElementToAppear = (selector, timeout = 5000) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()
    const intervalId = setInterval(() => {
      const targetElement = document.querySelector(selector)
      if (targetElement) {
        clearInterval(intervalId)
        resolve(targetElement)
      } else if (Date.now() - startTime > timeout) {
        clearInterval(intervalId)
        reject(
          new Error(
            `Timeout: Element '${selector}' not found within ${timeout}ms`
          )
        )
      }
    }, 50)
  })
}

const formatDatesInProperties = (originalProperties) => {
  var properties = { ...originalProperties } // Clone the object to keep the original intact

  try {
    for (var key in properties) {
      if (key.includes("Date")) {
        var value = properties[key]
        var parts = value.split("-")
        if (parts.length !== 3) throw new Error("Invalid date format")

        var year = parts[0]
        var month = parts[1] - 1 // Months are 0-indexed in JavaScript
        var day = parts[2]
        var date = new Date(year, month, day)

        // Validate if the date object is valid
        if (isNaN(date.getTime())) throw new Error("Invalid date")

        month = String(date.getMonth() + 1).padStart(2, "0")
        day = String(date.getDate()).padStart(2, "0")
        year = date.getFullYear()
        properties[key] = month + "-" + day + "-" + year
      }
    }
    return properties
  } catch (error) {
    console.error(error)
    return originalProperties // Return the original object if an error occurred
  }
}

/*
///////////////////
  Event Handlers
//////////////////
*/
minusButton.addEventListener("click", () => adjustQuantity("minus"))
plusButton.addEventListener("click", () => adjustQuantity("plus"))
radioInputs.forEach((input) => {
  input.addEventListener("change", () => {
    variantIdInput = document.querySelector('input[name="id"]:checked')
  })
})

/*
///////////////////
  Core Functions
//////////////////
*/
const createEmptyCartMessage = async () => {
  try {
    const drawerResponse = await axiosGet("?section_id=drawer-cart")
    const data = drawerResponse.data
    drawerCartTarget.innerHTML = data
  } catch (error) {
    console.error("Error:", error)
  }
}

const updateCartQuantityValue = (cartData, variantId) => {
  const cartItem = cartData.items.find((item) => item.id == variantId)
  if (!cartItem) return

  const cartQuantities = document.querySelectorAll(".global-cart-quantity")
  cartQuantities.forEach((cartQuantity) => {
    cartQuantity.textContent = cartData.item_count
  })

  document
    .querySelectorAll(`[data-id="${variantId}"]`)
    .forEach((cartItemQuantity) => {
      cartItemQuantity.value = cartItem.quantity
      const domItem = cartItemQuantity
        .closest(".drawer-line-item")
        .querySelector(".line-item-price")
      domItem.textContent = `$${(cartItem.final_line_price / 100).toFixed(2)}`
    })
}

const adjustDrawerItemQuantity = async (operation, item) => {
  const variantKey = item.closest("li").getAttribute("data-key")
  toggleSpinner(item.closest("li").querySelector(".loading-spinner"), true)

  const itemQuantityInput = item
    .closest(".quantity-selector")
    .querySelector(".global-cart-item-quantity")

  const newQuantity =
    operation === "minus"
      ? parseInt(itemQuantityInput.value) - 1
      : parseInt(itemQuantityInput.value) + 1

  if (newQuantity > 0) {
    try {
      const response = await axiosChange("/cart/change.js", {
        id: variantKey,
        quantity: newQuantity,
      })

      itemQuantityInput.value = newQuantity
      updateGlobalCartCount(response.data.item_count)

      const drawerResponse = await axiosGet("?section_id=drawer-cart")
      const data = drawerResponse.data
      drawerCartTarget.innerHTML = data

      toggleSpinner(item.closest("li").querySelector(".loading-spinner"), false)
    } catch (error) {
      toggleSpinner(item.closest("li").querySelector(".loading-spinner"), false)
      console.error("Could not update item quantity in cart", error)
    }
  } else {
    handleRemoveItem(item.closest("li"), variantKey)
  }
}

const updateGlobalCartCount = (itemCount) => {
  const cartQuantities = document.querySelectorAll(".global-cart-quantity")
  cartQuantities.forEach((cartQuantity) => {
    cartQuantity.textContent = itemCount
  })
}

const handleRemoveItem = async (item, variantKey) => {
  try {
    const response = await axiosChange("/cart/change.js", {
      id: variantKey,
      quantity: 0,
    })
    if (response.data.items.length === 0) {
      updateGlobalCartCount(0)
      await createEmptyCartMessage()
    } else {
      item.remove()
      document.querySelector("#drawer-sub-total").textContent = formatMoney(
        response.data.total_price,
        "${{amount}}"
      )
      updateGlobalCartCount(response.data.item_count)
    }
  } catch (error) {
    console.error("Could not remove item from cart", error)
  }
}

const updateVariant = (sku, price, compareAtPrice) => {
  var priceContainer = document.querySelector(".product-price")
  var productSkuElement = document.getElementById("product-sku")

  // Update the SKU
  if (productSkuElement) {
    productSkuElement.textContent = sku
  }

  if (compareAtPrice && compareAtPrice > price) {
    // Sale price is present
    priceContainer.innerHTML = `
        <div class="flex flex-row items-center">
        <div class="text-base text-gray-700 line-through">
          <span class="sr-only">Price:</span>
          <span id="compare-at-price">${compareAtPrice}</span>
        </div>
        <div class="flex flex-row justify-center md:justify-start space-x-3">
          <span class="sr-only">Price:</span>
          <span id="price">${price}</span>
          <div class="flex flex-row items-center space-x-1 sale-tag">
            <p class="text-base bg-red-500 px-2 text-white rounded-xl">Sale</p>
          </div>
        </div>
        </div>`
  } else {
    // No sale price
    priceContainer.innerHTML = `
        <div>
          <span class="sr-only">Price:</span>
          <span id="price">${price}</span>
        </div>`
  }
}

/*
///////////////////
  MAIN SUBMIT FUNCTION
//////////////////
*/

const submitForm = async (properties) => {
  const formattedProperties = formatDatesInProperties(properties)

  const variantId = variantIdInput.value
  const quantity = getQuantity()
  try {
    await axiosPost("/cart/add.js", {
      id: variantId,
      quantity: quantity,
      properties: formattedProperties,
    })
    const response = await axiosGet("/cart.js")
    window.dispatchEvent(new CustomEvent("cart-updated"))
    updateCartQuantityValue(response.data, variantId)
    const drawerResponse = await axiosGet("?section_id=drawer-cart")
    const data = drawerResponse.data
    drawerCartTarget.innerHTML = data
  } catch (error) {
    console.error("Could not add item to cart", error)
  }
}

if (productForm) {
  productForm.addEventListener("submit", function (event) {
    event.preventDefault()
    const customFields = document.querySelectorAll(".custom-line-item-field")
    var properties = Array.from(customFields).reduce(function (acc, field) {
      var name = field.name
      var value = field.value
      if (field.type === "date") {
        // Split the value into [year, month, day]
        var parts = value.split("-")
        var year = parts[0]
        var month = parts[1] - 1 // Months are 0-indexed in JavaScript
        var day = parts[2]
        // Construct the date without time part
        var date = new Date(year, month, day)
        month = String(date.getMonth() + 1).padStart(2, "0")
        day = String(date.getDate()).padStart(2, "0")
        year = date.getFullYear()
        value = month + "-" + day + "-" + year
      }
      name = name.replace("properties[", "").replace("]", "")
      return { ...acc, [name]: value }
    }, {})

    if (customFields.length > 0) {
      confirmationModal.classList.remove("hidden")
      const customFieldsList = document.getElementById("custom-fields-list")
      customFieldsList.innerHTML = ""
      for (var key in properties) {
        if (properties.hasOwnProperty(key)) {
          var value = properties[key]
          var p = document.createElement("p")
          var keySpan = document.createElement("span")
          keySpan.textContent = key
          keySpan.classList.add("text-sm", "text-gray-600")
          var valueSpan = document.createElement("span")
          valueSpan.textContent = value
          valueSpan.classList.add("text-lg", "font-bold", "font-serif")
          p.appendChild(keySpan)
          p.appendChild(document.createTextNode(": "))
          p.appendChild(valueSpan)
          customFieldsList.appendChild(p)
        }
      }
    } else {
      submitForm(properties)
    }
  })
}

/*
///////////////////
  Popovers
//////////////////
*/
const infoButtons = document.querySelectorAll(".info-button")

// Hide all popovers
const hideAllPopovers = () => {
  const popovers = document.querySelectorAll(".popover")
  popovers.forEach((popover) => {
    popover.classList.add("hidden")
    popover.previousElementSibling.setAttribute("aria-expanded", "false")
  })
}

infoButtons.forEach((infoButton) => {
  infoButton.addEventListener("click", function (event) {
    event.preventDefault()
    event.stopPropagation()

    // First hide all popovers
    hideAllPopovers()

    // Then show the clicked one
    let popover = this.nextElementSibling
    popover.classList.remove("hidden")
    popover.setAttribute("aria-expanded", "true")
  })
})

// Hide the popover when you click anywhere else on the page
document.addEventListener("click", function (event) {
  if (!event.target.matches(".info-button")) {
    hideAllPopovers()
  }
})
